// extracted by mini-css-extract-plugin
export default {"z1080":"ToastDiv_z1080__QePt1"};